module.exports = __webpack_public_path__ + "img/product_87.73556a7.webp";